import React from "react";

import { formatNumber } from "~/utils/bloodGlucoseFormatters";
import { HealthSummary } from "../Shared";

interface BloodGlucoseData {
  date: string;
  low: number;
  high: number;
  avg: number;
  hour?: number;
  datetime?: string;
}

interface BloodGlucoseSummaryProps {
  filteredData: BloodGlucoseData[];
  metadata: {
    average: number;
    min: number;
    max: number;
  } | null;
  handlePrevious: () => void;
  handleNext: () => void;
  onDateSelect: (date: Date) => void;
  selectedDate: Date;
  selectedRange: string;
}

export const BloodGlucoseSummary: React.FC<BloodGlucoseSummaryProps> = ({
  filteredData,
  metadata,
  handlePrevious,
  handleNext,
  onDateSelect,
  selectedDate,
  selectedRange,
}) => {
  const getSummaryValues = (metadata: { average: number; min: number; max: number } | null, _filteredData: BloodGlucoseData[]) => [
    {
      label: "Low",
      value: formatNumber(metadata?.min ?? 0),
      color: "#3b82f6", // blue-500
      unit: "mg/dL",
    },
    {
      label: "Avg",
      value: formatNumber(metadata?.average ?? 0),
      color: "#22c55e", // green-500
      unit: "mg/dL",
    },
    {
      label: "High",
      value: formatNumber(metadata?.max ?? 0),
      color: "#ef4444", // red-500
      unit: "mg/dL",
    },
  ];

  return (
    <HealthSummary
      filteredData={filteredData}
      metadata={metadata}
      handlePrevious={handlePrevious}
      handleNext={handleNext}
      onDateSelect={onDateSelect}
      selectedDate={selectedDate}
      selectedRange={selectedRange}
      getSummaryValues={getSummaryValues}
    />
  );
};